import http from './http';

/**
 * 文件管理相关接口（列表 / 目录树 / 元数据 / 删除 / 黑白名单 / 移动 / 重命名）
 */

/** 文件列表（管理端），params: { dir, start, count, search, includeTags, excludeTags, recursive, ...筛选 } */
export function list(params, config = {}) {
  return http.get('/api/file/list', { params, ...config });
}

/** 公开文件列表（公开浏览页），params: { dir, start, count, search, type } */
export function publicList(params, config = {}) {
  return http.get('/api/file/public/list', { params, ...config });
}

/** 目录树 */
export function directoryTree(config = {}) {
  return http.get('/api/file/directoryTree', config);
}

/** 文件元数据 */
export function metadata(fileId) {
  return http.get(`/api/file/metadata/${encodeURIComponent(fileId)}`);
}

/** 删除文件 / 文件夹 */
export function remove(name, { isFolder } = {}) {
  return http.get(`/api/file/delete/${encodeURIComponent(name)}`, {
    params: isFolder !== undefined ? { folder: isFolder } : {},
  });
}

/** 拉黑文件 */
export function block(name) {
  return http.get(`/api/file/block/${encodeURIComponent(name)}`);
}

/** 解除拉黑（白名单） */
export function white(name) {
  return http.get(`/api/file/white/${encodeURIComponent(name)}`);
}

/** 移动文件 / 文件夹 */
export function move(name, { isFolder, dist }) {
  return http.get(`/api/file/move/${encodeURIComponent(name)}`, {
    params: { folder: isFolder, dist },
  });
}

/** 更新文件元数据（文件名 / 类型等） */
export function updateMetadata(fileId, data) {
  return http.patch(`/api/file/metadata/${encodeURIComponent(fileId)}`, data);
}

/** 重命名 */
export function rename(oldFileId, data) {
  return http.post(`/api/file/rename/${encodeURIComponent(oldFileId)}`, data);
}
